import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Paper from '@mui/material/Paper'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined'
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined'
import { getAccess } from '../../helpers/ReduxHelpers'

const TABS = [
  { label: 'Dashboard',  path: '/intervention/dashboard',        icon: <DashboardOutlinedIcon sx={{ fontSize: 18 }} /> },
  { label: 'NDR',        path: '/intervention/ndr',              icon: <ReportProblemOutlinedIcon sx={{ fontSize: 18 }} /> },
  { label: 'NPR',        path: '/intervention/npr',              icon: <LocalShippingOutlinedIcon sx={{ fontSize: 18 }} /> },
  { label: 'Calls',      path: '/intervention/calls',            icon: <PhoneInTalkOutlinedIcon sx={{ fontSize: 18 }} /> },
  { label: 'WhatsApp',   path: '/intervention/whatsapp',         icon: <WhatsAppIcon sx={{ fontSize: 18 }} /> },
  { label: 'Templates',  path: '/intervention/templates',        icon: <DescriptionOutlinedIcon sx={{ fontSize: 18 }} /> },
  { label: 'Rules',      path: '/intervention/rules',            icon: <AutoFixHighOutlinedIcon sx={{ fontSize: 18 }} /> },
  { label: 'Cost',       path: '/intervention/cost',             icon: <PaidOutlinedIcon sx={{ fontSize: 18 }} />, access: 'INTERVENTION_COST' },
]

export default function InterventionNav() {
  const location = useLocation()
  const navigate = useNavigate()
  const userAccess = getAccess() || []

  const visibleTabs = TABS.filter(t => !t.access || userAccess.includes(t.access) || userAccess.includes('SA'))

  const activeIdx = Math.max(0, visibleTabs.findIndex(t => location.pathname.startsWith(t.path)))

  return (
    <Paper sx={{ px: 1 }}>
      <Tabs
        value={activeIdx}
        onChange={(_, idx) => navigate(visibleTabs[idx].path)}
        variant='scrollable'
        scrollButtons='auto'
        sx={{
          '& .MuiTab-root': { minHeight: 48, py: 1 },
          '& .MuiTabs-indicator': { height: 3, borderRadius: '3px 3px 0 0' },
        }}
      >
        {visibleTabs.map(t => (
          <Tab key={t.path} label={t.label} icon={t.icon} iconPosition='start' />
        ))}
      </Tabs>
    </Paper>
  )
}
